var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMultiTag = function SvgMultiTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.34 2.021a2.004 2.004 0 0 1 1.612.485l6.812 6.055a2 2 0 0 1 .166 2.823l-5.262 5.92a2 2 0 0 1-2.909.086L.966 10.597A2 2 0 0 1 .401 8.9l.646-4.525a2 2 0 0 1 1.696-1.697l4.597-.656ZM4.759 4.89a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 4.76 4.89Z",
    style: {
      fillRule: "evenodd"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.34 2.02a2.002 2.002 0 0 1 1.611.485l5.317 4.727a4 4 0 0 1 .332 5.646l-3.934 4.426a1.998 1.998 0 0 1-2.814.171l4.824-5.427.1-.118a3 3 0 0 0-.236-4.012l-.112-.105-6.319-5.617 1.231-.176Z"
  })));
};
export default SvgMultiTag;